// Hook to access runtime configuration
export const useConfig = () => {
  const config = window.__RUNTIME_CONFIG__ || {};
  
  return {
    branchSignupUrl: config.BRANCH_SIGNUP_URL || '/pricing',
    companySignupUrl: config.COMPANY_SIGNUP_URL || '/pricing',
  };
};

export default useConfig;
